import { ResourceQuery } from './ResourceQuery';
import { IListFetcher } from '../fetchers/IListFetcher';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { ISharedVersionInfo } from '../models/ISharedVersionInfo';
import { Module } from '../Module';
import { FetcherFactory } from '../services/FetcherFactory';
import { GetShareActivityRequest, IGetShareActivityResult } from '../ServerApi/requests/GetShareActivityRequest';
import { ServerService } from '../services/ServerService';

export class ShareActivity {
  public static $inject = ['ServerService', 'FetcherFactory'];

  private getSharedVersionInfo: IListFetcher<ISharedVersionInfo>;

  constructor(private server: ServerService, FetcherFactory: FetcherFactory) {
    this.getSharedVersionInfo = FetcherFactory.getServerResourceFetcher(GetShareActivityRequest, ServerApiMapper.shareActivity);
  }

  public getShareActivity(viewId: string): ng.IPromise<ISharedVersionInfo[]> {
    return this.server.sendRequest(new GetShareActivityRequest({
      viewId
    })).then((result: IGetShareActivityResult) => {
      return ServerApiMapper.shareActivity(result);
    });
  }
}

Module.instance().service('ShareActivity', ShareActivity);

